<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col cols="12">
            <b-row class="pb-1">
              <b-col cols="12">
                <h4>Danh sách phòng ban</h4>
              </b-col>
            </b-row>
            <b-row class="pb-1">
              <b-col class="text-left" cols="5">
                <b-button class="btn-sm mr-50" variant="primary" @click="New()">
                  <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
                  Thêm mới
                </b-button>
              </b-col>
              <b-col cols="6">
                <b-input-group>
                  <b-form-input v-model="searchQuery" placeholder="Tìm kiếm " v-on:keydown.enter="quickSearch"/>
                  <b-input-group-append is-text role="button" @click="quickSearch">
                    <feather-icon icon="SearchIcon"/>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <vue-good-table :columns="options.fields" :isLoading.sync="isLoading" :line-numbers="true" :rows="items"
                                :select-options="{ enabled: true }" :totalRows="totalRecords"
                                mode="remote"
                                @on-page-change="onPageChange" @on-sort-change="onSortChange"
                                @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange" @on-selected-rows-change="selectionChanged">
                  <template slot="table-row" slot-scope="props">
                    <!-- Column: Action -->
                    <span v-if="props.column.field === 'action'">
                      <span>
                        <b-button class="btn-icon" size="sm" variant="primary" @click="Edit(props.row, props.row.id)">
                          <feather-icon icon="Edit2Icon"/>
                        </b-button>
                        <b-button class="btn-icon" size="sm" style="margin-left: 6px" variant="danger"
                                  @click="DeleteItem(props.row, props.row.id)">
                          <feather-icon icon="TrashIcon"/>
                        </b-button>
                      </span>
                    </span>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-modal id="modal-edit" :title="getTitle()" size="xl" @ok="handleOk">
      <form ref="form">
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label>Tên phòng ban <span class='text-danger'>*</span></label>
              <b-form-input v-model="currentItem.name" :state="validateState('name')" max-length="255"
                            placeholder="Nhập tên phòng ban" required/>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group>
              <label>Trạng thái <span class='text-danger'>*</span></label>
              <Select2 v-model="currentItem.status" :options="statusList" :state="validateState('status')"/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <label>Địa chỉ</label>
              <b-form-input v-model="currentItem.address" max-length="255" placeholder="Nhập địa chỉ phòng ban"/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <label>Số liên hệ</label>
              <b-form-input v-model="currentItem.tel" max-length="20" placeholder="Nhập số liên hệ" type="phone"/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <label>Thứ tự</label>
              <b-form-input v-model="currentItem.sort_order" max="9999999" min="0" type="number"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Mô tả phòng ban">
              <b-form-textarea v-model="currentItem.description" max-length="500" max-rows="10" placeholder="Mô tả phòng ban"
                               rows="5"/>
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-modal>
  </div>
</template>

<script>

import {ValidationObserver, ValidationProvider} from "vee-validate";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import {getuserName} from "@/@core/utils/utils";


export default {
  name: "adminTopic",
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BFormTextarea,
    BInputGroup, BInputGroupAppend
  },
  methods: {
    validateState(pro) {
      if (!this.isSubmit) return null;
      if (!this.currentItem[pro]) return false;
      else return true;
      return null;
    },
    getTitle() {
      if (this.editMode) {
        return "Cập nhật phòng ban ";
      } else {
        return "Thêm mới phòng ban ";
      }
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.serverParams.page = 1;
      this.updateParams(params);
      console.log(this.serverParams);
      this.loadItems();
    },
    loadItems() {
      try {
        this.loading(true);
        useJwt
            .get("portal/departments?filter=" + this.searchQuery, {
              columnFilters: {},
            })
            .then((response) => {
              this.items = response.data.result;
              this.totalRecords = response.data.totalRecords;
              this.loading(false);
              this.isLoading = false;
            });
      } catch {
        this.loading(false);
      }

    },

    New() {
      this.currentItem = {};
      this.editMode = false;
      this.modal_title = "Thêm mới phòng ban ";
      this.$bvModal.show("modal-edit");
    },

    async Edit(item) {
      this.currentItem = item;
      this.editMode = true;
      this.modal_title = "Cập nhật phòng ban";
      this.$bvModal.show("modal-edit");
    },

    async DeleteItem(item, index, button) {
      this.currentItem = item;
      const url = `portal/departments/${item.id}`;
      let resModal = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá dữ liệu phòng ban",
          {title: "Please Confirm", size: "sm"}
      );
      if (resModal) {
        try {
          this.loading(true);
          let res = await useJwt.delete(url);
          this.loading(false);
          if (res.data.code == 200) {
            this.loaddepartment();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Xoá phòng ban thành công!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: res.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi xoá phòng ban ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }
    },
    selectionChanged(params) {
      this.rowSelection = params.selectedRows;
    },
    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.isSubmit = true;
      const bIsValid = await this.isValid(this.currentItem);
      if (!bIsValid) {
        return;
      }
      const userName = getuserName();
      if (this.editMode) {
        const url = `portal/departments/${this.currentItem.id}`;

        const updateParams = {
          id: this.currentItem.id,
          name: this.currentItem.name,
          status: this.currentItem.status,
          sort_order: this.currentItem.sort_order,
          description: this.currentItem.description,
          address: this.currentItem.address,
          tel: this.currentItem.tel,
          created_at: userName,
          updated_at: userName
        };
        try {
          this.loading(true);
          const res = await useJwt.put(url, updateParams);
          this.loading(false);
          if (res.data.code == 200) {
            this.isSubmit = false;
            this.loadItems();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Cập nhật thành công!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
            this.$bvModal.hide("modal-edit");
            return;
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi cập nhật phòng ban ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return
        }
      }
      try {
        const createParams = {
          id: 0,
          name: this.currentItem.name,
          status: this.currentItem.status,
          sort_order: this.currentItem.sort_order,
          description: this.currentItem.description,
          address: this.currentItem.address,
          tel: this.currentItem.tel,
          updated_at: userName,
          created_at: userName
        };
        this.loading(true);
        const res = await useJwt.post("portal/departments", createParams);
        this.loading(false);
        if (res.data.code == 200) {
          this.isSubmit = false;
          this.loadItems();
          this.$bvModal.hide("modal-edit");
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thêm mới phòng ban thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }
      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi thêm mới phòng ban ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    async isValid(item) {
      if (!item.name) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Tên không được để trống",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }
      if (item.status == null || item.status === '' || item.status == undefined) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Trạng thái không được để trống.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }

      return true;
    },
    async loaddepartment() {
      try {
        this.loading(true);
        useJwt.get("portal/departments?filter=" + this.searchQuery).then((response) => {
          var result = response.data;
          if (result.code == 200) {
            this.items = result.result;
            this.totalRecords = result.totalRecords;
            // this.items.forEach(item => {
            //   this.departmentSelect.push({ 'id': item.id, 'text': item.name });
            // });
          }
          this.isLoading = false;
          this.loading(false);
        });
      } catch (ex) {
        this.loading(false);
      }
    },
    async quickSearch() {
      this.loaddepartment();
    }
  },

  mounted() {
    this.loaddepartment();
    this.isSubmit = false;
  },
  data() {
    return {
      isLoading: false,
      isSubmit: false,
      totalRecords: 0,
      items: [],
      statusList: [
        {id: 1, text: "Hoạt động"},
        {id: 0, text: "Ngừng hoạt động"}
      ],
      editMode: false,
      totalItem: 0,
      searchQuery: "",
      currentItem: {},
      rowSelection: [],
      options: {
        fields: [
          {field: "action", label: "Cài đặt", width: "120px"},
          {
            field: "name",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Tên phòng ban",
            required: true,
            disabled: true,
          },
          {
            field: "created_date",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Ngày tạo",
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss',
            dateOutputFormat: 'dd/MM/yyyy HH:mm:ss',
            required: true,
            disabled: true,
          },
          {
            field: "statusName",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Trạng thái",
            required: true,
            disabled: true,
          }
        ],
        fieldSubs: [
          {field: "action", label: "Thao tác", width: "120px"},
          {
            field: "name",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Tên chủ đề",
            required: true,
            disabled: true,
          },
          {
            field: "created_date",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Ngày tạo",
            required: true,
            disabled: true,
          },
          {
            field: "statusName",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Trạng thái",
            required: true,
            disabled: true,
          }
        ]
      },
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
select[readonly].select2 + .select2-container {
  pointer-events: none;
  touch-action: none;

  .select2-selection {
    background: #eee;
    box-shadow: none;
  }

  .select2-selection__arrow,
  .select2-selection__clear {
    display: none;
  }
}
</style>
